module.exports = __webpack_public_path__ + "img/org-shell.71525e95.jpg";